export default "__VITE_ASSET__DC93gRCu__"